import aircraftCatalog from "../data/aircraftCatalog.json";

export default function FleetTab(props) {
  const {
    game,
    routes,
    airports,
    number,
    money,
    airportTypeLabel,
    planeCondition,
    planeValue,
    serviceCost,
    getAirport,
    onBuyPlane,
    onServicePlane,
    onSellPlane
  } = props;

  const usedPlaneIds = new Set(routes.map(function (route) { return route.planeId; }));

  return (
    <div className="tabContent">
      <div className="sectionTitle">
        <div>
          <h2>Letadla</h2>
          <p>Levnější stroje se hodí na kratší a regionální linky. Větší kapacita se vyplatí až na silnějších trasách.</p>
        </div>
        <strong>{money(game.cash)}</strong>
      </div>

      <details className="fold" open>
        <summary>Nákup letadel</summary>
        <div className="shopGrid detailed">
          {aircraftCatalog.map(function (item) {
            const affordable = game.cash >= item.price;
            return (
              <article key={item.model} className="planeCard">
                <div className="planeCardHeader">
                  <div className="planeCardInfo">
                    <h3>{item.model}</h3>
                    <p>{item.role}</p>
                  </div>
                  <img src={item.image} alt={item.model} />
                </div>
                <div className="planeCardBody">
                  <div className="statGrid">
                    <span><b>{number(item.range)} km</b><em>dolet</em></span>
                    <span><b>{item.seats}</b><em>míst</em></span>
                    <span><b>{number(item.speed)} km/h</b><em>rychlost</em></span>
                    <span><b>{money(item.maintenance)}</b><em>běžná údržba</em></span>
                    <span><b>{number(item.fuelPerKm)} $/km</b><em>palivo</em></span>
                    <span><b>{airportTypeLabel(item.airportNeed)}</b><em>vhodné pro</em></span>
                  </div>
                  <button disabled={!affordable} onClick={function () { onBuyPlane(item); }}>{money(item.price)}</button>
                </div>
              </article>
            );
          })}
        </div>
      </details>

      <details className="fold" open>
        <summary>Moje flotila</summary>
        {game.fleet.length === 0 && <p className="emptyText">Zatím nemáš žádné letadlo.</p>}
        <div className="ownedGrid">
          {game.fleet.map(function (plane) {
            const used = usedPlaneIds.has(plane.id);
            const assignedRoute = routes.find(function (route) { return route.planeId === plane.id; });
            const routeOrigin = assignedRoute ? getAirport(airports, assignedRoute.originId) : null;
            const routeDestination = assignedRoute ? getAirport(airports, assignedRoute.destinationId) : null;
            return (
              <article key={plane.id} className="ownedPlane">
                <img src={plane.image} alt={plane.model} />
                <div>
                  <strong>{plane.model}</strong>
                  <span>{used && routeOrigin && routeDestination ? `${routeOrigin.iata || routeOrigin.icao} ⇄ ${routeDestination.iata || routeDestination.icao}` : "volné letadlo"}</span>
                </div>
                <div className="statGrid compact">
                  <span><b>{number(plane.range)} km</b><em>dolet</em></span>
                  <span><b>{plane.seats}</b><em>míst</em></span>
                  <span><b>{Math.round(planeCondition(plane))}%</b><em>stav</em></span>
                  <span><b>{money(serviceCost(plane))}</b><em>servis</em></span>
                  <span><b>{money(planeValue(plane))}</b><em>prodej</em></span>
                </div>
                <div className="planeActions">
                  <button disabled={used || planeCondition(plane) >= 99} onClick={function () { onServicePlane(plane.id); }}>{used ? "Na lince" : "Servis"}</button>
                  <button disabled={used} onClick={function () { onSellPlane(plane.id); }}>{used ? "Na lince" : "Prodat"}</button>
                </div>
              </article>
            );
          })}
        </div>
      </details>
    </div>
  );
}
